module.exports = require("core-js-pure/stable/instance/values");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js-stable/instance/values.js
// module id = 4377
// module chunks = 25